import api from './api';
import { BASE_URL } from "./constant";
import axios from "axios"; 

export const registerNas = async (serviceData) => {
  try {
    const response = await api.post('/api/nas/add', serviceData);
    if (response.status !== 201) {
        throw new Error("Échec de la création");
      }
      return response.data;
  } catch (error) {
    console.error('Error creating service:', error);
    throw error;
  }
};
export const registerGroup = async (serviceData) => {
  try {
    const response = await api.post('/api/radius-group/add', serviceData);
    if (response.status !== 201) {
        throw new Error("Échec de la création");
      }
      return response.data;
  } catch (error) {
    console.error('Error creating service:', error);
    throw error;
  }
};


export const fetchNas= async () =>  {
  try{
    const response = await api.get("/api/nas");
      //console.log(response);
      return response.data.data;
  } catch (error) {
    console.error("Erreur lors du login:", error);
    throw error;
  }
};
export const fetchGroup= async () =>  {
  try{
    const response = await api.get("/api/radius-group");
      //console.log(response);
      return response.data.data;
  } catch (error) {
    console.error("Erreur lors du login:", error);
    throw error;
  }
};

export async function updateRadius(id, form) {
  try {
    const res = await fetch(`${BASE_URL}api/nas/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id,
        ...form, // 🔥 IMPORTANT (on éclate l'objet)
      }),
    });

    const data = await res.json();
    return data;
  } catch (err) {
    console.warn("Update radius failed", err);
  }
}

export async function updateGroup(id, formGroup) {
  try {
    const res = await fetch(`${BASE_URL}api/radius-group/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id,
        ...formGroup,
      }),
    });

    const data = await res.json();
    return data;
  } catch (err) {
    console.warn("Update group failed", err);
  }
}

export async function deleteRadius(id) {
  try {
    const res = await axios.delete(
      `${BASE_URL}api/nas/${id}`
    );
    return res.data;
  } catch (err) {
    console.error("deleteVideoConfig failed:", err);
    throw err;
  }
}
export async function deleteGroup(id) {
  try {
    const res = await axios.delete(
      `${BASE_URL}api/radius-group/${id}`
    );
    return res.data;
  } catch (err) {
    console.error("deleteVideoConfig failed:", err);
    throw err;
  }
}



